import ria from './ria'
import rira from './rira'

export default baseUrl => {
    baseUrl = `${baseUrl}/integracao`

    return {
        ria: ria(baseUrl),
        rira: rira(baseUrl),
    }
}
